class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.threshold = 300;
    this.ticking = false;
    this.lastProgress = null;
    this.maxScroll = 1;
  }

  connectedCallback() {
    this.button = this.querySelector('.back-to-top__button');
    this.progressPath = this.querySelector('.back-to-top__progress-bar');

    if (this.progressPath) {
      this.pathLength = this.progressPath.getTotalLength();
      this.progressPath.style.strokeDasharray = `${this.pathLength} ${this.pathLength}`;
      this.progressPath.style.strokeDashoffset = this.pathLength;
    }

    this.button?.addEventListener('click', this.scrollToTop.bind(this));

    this.handleScroll = this.onFrame.bind(this);
    this.handleResize = this.measure.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });

    this.measure();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  // Layout is read once on load and on resize — never per frame.
  measure() {
    this.maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    this.update();
  }

  onFrame() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const y = window.scrollY || window.pageYOffset;
    this.classList.toggle('is-visible', y > this.threshold);
    if (!this.progressPath) return;
    const progress = this.pathLength - (y * this.pathLength) / this.maxScroll;
    if (this.lastProgress !== progress) {
      this.progressPath.style.strokeDashoffset = progress;
      this.lastProgress = progress;
    }
  }

  scrollToTop(e) {
    e.preventDefault();
    window.scroll({ top: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}